import React from 'react';
import { useSelector } from 'react-redux';
import { defineMessage } from 'react-intl';

import ReuseableGridButton from '../../components/grid-header/reusable-grid-button';
import Global from '../../store/global-selectors';
import { CancelFulfillmentModal } from '../../shipping/fulfillments/components/cancel-fulfillment-modal';
import { useModal } from '../../hooks/use-modal';
import ModalPortal from '../../components/modal-portal';

const cancelFulfillmentMessage = defineMessage({
  description: 'Order Grid Pending Fulfillment Cancel Fulfillments Button text',
  defaultMessage: 'Cancel Fulfillment',
  id: 'sS88FT',
});
const tooltipMessage = defineMessage({
  description: 'Order Grid Pending Fulfillment Cancel Fulfillments Button tooltip text',
  defaultMessage: 'Send a cancel request to the fulfillment provider.',
  id: 'RZEs/u',
});

export const CancelFulfillmentButton = () => {
  const { open, isOpen, close } = useModal();
  const selectedFulfillmentIds = useSelector(Global.selectSelectedOrdersIds);
  const disabled = selectedFulfillmentIds.length === 0;

  return (
    <>
      <ReuseableGridButton
        actionHandler={open}
        disable={disabled}
        hasTooltip
        messageDescriptor={cancelFulfillmentMessage}
        theme='tertiary'
        tooltipMessageDescriptor={tooltipMessage}
      />
      {isOpen && (
        <ModalPortal onClose={close}>
          <CancelFulfillmentModal fulfillmentPlanIds={selectedFulfillmentIds} onClose={close} />
        </ModalPortal>
      )}
    </>
  );
};
